import { render, staticRenderFns } from "./smartChat.vue?vue&type=template&id=3115b890&scoped=true"
import script from "./smartChat.vue?vue&type=script&lang=js"
export * from "./smartChat.vue?vue&type=script&lang=js"
import style0 from "./smartChat.vue?vue&type=style&index=0&id=3115b890&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3115b890",
  null
  
)

export default component.exports